// صف الإجماليات أسفل جدول تقرير الحضور — يطابق أرقام البطاقات بنظرة واحدة.
import { esc } from "../payroll/reportFormat";

const sum = (rows, pick) => rows.reduce((total, row) => total + (Number(pick(row)) || 0), 0);

export const attTotalsRow = (data, L) => {
  const rows = data.employees || [];
  if (!rows.length) return "";
  return `<tfoot><tr class="totals">
    <td class="b">${esc(L.totalsLabel)} (${rows.length})</td>
    <td>${sum(rows, (r) => r.days_worked)}</td>
    <td>${sum(rows, (r) => r.absence_days)}</td>
    <td>${sum(rows, (r) => r.late_count)}</td>
    <td>${sum(rows, (r) => r.leave_days)}</td>
    <td>${sum(rows, (r) => r.total_weekends)}/${sum(rows, (r) => r.paid_weekends)}</td>
  </tr></tfoot>`;
};
